/*
akhila    10/28/2022 3075154998 enable framework UX changes
 */
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import FilterSubTabs from './Filter/SubTabs';
import MediaType from './MediaType';
import FilterGroup from './FilterGroup';
import EnableFileFormat from './EnableFileFormat';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    borderRadius: '5px',
  },
  padding: {
    padding: theme.spacing(3),
  },
  demo1: {
    backgroundColor: '#296bff',
    color: 'white',
    borderRadius: '6px',
  },
}));

export default function EnableFrameworkTabs({value, setValue}) {
  const classes = useStyles();


  return (
    <div className={classes.root}>
      <div>
        <Typography />
      </div>
      <div className={classes.subContent}>
        {value === 0 && <FilterSubTabs />}
        {value === 1 && <FilterGroup />}
        {value === 2 && <MediaType />}
        {value === 3 && <EnableFileFormat />}
      </div>
    </div>
  );
}
